/**
 * Deep linking support for PWA installation
 */

interface AppState {
  path: string;
  query: string;
  data?: any;
}

const STORAGE_KEY = 'veripay_pwa_state';

/**
 * Saves the current app state before installation
 */
export const saveAppState = (additionalData?: any): void => {
  const currentState: AppState = {
    path: window.location.pathname,
    query: window.location.search,
    data: additionalData
  };
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(currentState));
};

/**
 * Restores the app state after installation
 * @returns true if state was restored, false otherwise
 */
export const restoreAppState = (): boolean => {
  const savedState = localStorage.getItem(STORAGE_KEY);
  
  if (savedState) {
    try {
      const state: AppState = JSON.parse(savedState);
      
      // Navigate to the saved state
      window.history.replaceState({}, '', state.path + state.query);
      
      // Clear the saved state
      localStorage.removeItem(STORAGE_KEY);
      
      return true;
    } catch (e) {
      console.error('Failed to restore app state', e);
    }
  }
  
  return false;
};

/**
 * Checks if there's a saved state to restore
 */
export const hasSavedState = (): boolean => {
  return localStorage.getItem(STORAGE_KEY) !== null;
};

/**
 * Gets the saved app state without restoring it
 */
export const getSavedState = (): AppState | null => {
  const savedState = localStorage.getItem(STORAGE_KEY);
  
  if (savedState) {
    try {
      return JSON.parse(savedState);
    } catch (e) {
      console.error('Failed to parse saved state', e);
    }
  }
  
  return null;
};